import { useRef, useState, FC } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useAppDispatch } from 'app/store';
import { addParticipantsToCompetitionsThunk } from 'entities/competitions-b2b/thunk';
import css from './style.module.css';
import ParticipantsXlsxWarnings, { IWarning } from '../ParticipantsXlsxWarnings';

/**
 * Назначить участников с помощью xlsx-файла
 */
const ParticipantsXlsxLoader: FC<{
  participants: number;
  competitionId: number;
}> = ({ participants, competitionId }) => {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [loading, setLoading] = useState(false);
  const [warnings, setWarnings] = useState<IWarning[]>([]);

  const handleOnChange = async (file: File) => {
    if (!competitionId) return;
    setLoading(true);

    const data = await dispatch(
      addParticipantsToCompetitionsThunk({
        file,
        competition_id: competitionId,
      }),
    );

    // @ts-ignore
    setWarnings(data.payload?.warnings);
    setLoading(false);
  };

  return (
    <div className={css.container}>
      <div className={css.block}>
        <p className={css.title}>
          Участники: <span>{participants}</span>
        </p>
        <div className={css.box}>
          <input
            className={css.input}
            ref={inputRef}
            type="file"
            onChange={(e) => {
              setWarnings([]);
              if (e.target?.files) {
                handleOnChange(e.target?.files[0]);
                e.target.value = '';
              }
            }}
          />
          <Button
            className={css.button}
            onClick={() => inputRef.current?.click()}
            disabled={loading}
          >
            Добавить участников (.xlsx)
          </Button>
          {loading ? (
            <div className={css.loader}>
              <CircularProgress size={20} />
            </div>
          ) : null}
        </div>
      </div>
      {warnings && warnings.length ? (
        <div className={css.table}>
          <ParticipantsXlsxWarnings data={warnings} />
        </div>
      ) : null}
    </div>
  );
};

export default ParticipantsXlsxLoader;
